export default function () {
    function tabify(element) {
        const header = element.querySelector('.bjs-tabs-header');
        const content = element.querySelector('.bjs-tabs');
        const tabHeaders = [...header.children];
        const tabContents = [...content.children];
        tabContents.forEach(function (x) {
            x.classList.remove('active');
        });
        let currentTabIndex = -1;

        function setTab(index) {
            if (currentTabIndex > -1) {
                tabHeaders[currentTabIndex].classList.remove('active');
                tabContents[currentTabIndex].classList.remove('active');
            }
            tabHeaders[index].classList.add('active');
            tabContents[index].classList.add('active');
            currentTabIndex = index;
        }
        let defaultTabIndex = tabHeaders.findIndex(x => {
            return [...x.classList].indexOf('default-gator-tab') > -1;
        });

        defaultTabIndex = defaultTabIndex === -1 ? 0 : defaultTabIndex;
        setTab(defaultTabIndex);
        tabHeaders.forEach(function (x, i) {
            x.onclick = event => setTab(i);
        });
    }

    // this is where the magic happens!
    [...document.querySelectorAll('.bjs-tabs-container')]
        .forEach(x => tabify(x));
};
